import React from 'react';
import moment from 'moment';
 import TimeAgo from 'react-time-ago'
import DashIcon from 'react-icons/lib/md/linear-scale';

const IataPendingdRecord = ({report}) => {

    return (
        <div className="timeline-box-w processing">
            <div className="timeline-time">
            <span>
                <TimeAgo>{ parseInt(moment(report.EntryDateTime).format('x'), 0)}</TimeAgo>
            </span>
            </div>
            <div className="timeline-box">
                <div className="timeline-info">
                    <h6 className="timeline-role">
                        {report.AirlineName}
                    </h6>

                    <h6>
                        { moment((report.SearchStartDate).split('T')[0]).format('MMM Do, YYYY')}
                        &nbsp;&nbsp;
                        <DashIcon size="22" color="#212121"/>
                        &nbsp;&nbsp;
                        { moment((report.SearchEndDate).split('T')[0]).format('MMM Do, YYYY')}
                    </h6>
                    <p className="timeline-title m-0">
                        Report was initiated on <strong>{ moment((report.EntryDate).split('T')[0]).format('MMM Do, YYYY')}</strong>
                    </p>
                    <div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IataPendingdRecord;


// WEBPACK FOOTER //
// ./src/views/iata/iata-pending-record.js